/*
 * @Author: zhenfangyu 2211267244@qq.com
 * @Date: 2024-06-05 11:33:51
 * @LastEditors: zhenfangyu
 * @LastEditTime: 2025-07-02 14:52:26
 * @FilePath: \jzt-kf-h5\src\utils\auth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Cookies from 'js-cookie'

export const TokenKey = 'CONVERAATION_TOKEN'
const GRAYSCALE_KEY = 'shade'
const GRAYSCALE_VALUE = 'shadeValue'
const GRAYSCALE_vALUE = 'shadevalue'

export function getGrayscaleMark() {
  // 获取灰度用户标记
  return Cookies.get(GRAYSCALE_KEY)
}

export function getGrayscaleMarkValue() {
  // 获取灰度用户标记值
  return Cookies.get(GRAYSCALE_VALUE)
}

export function getGrayscaleMarkvalue() {
  // 获取灰度用户标记值
  return Cookies.get(GRAYSCALE_vALUE)
}

export function setGrayscaleMark(value) {
  // 灰度用户标记设置key
  const domain = document.domain
  const time = new Date(new Date() * 1 + 24 * 60 * 60 * 1000)
  // Cookies.set(TokenKey, token, { expires: time, domain, path: '/' })
  // 字符串拼接cookie
  const configStr =
    process.env.NODE_ENV === 'development'
      ? GRAYSCALE_KEY + '=' + value + ';expires=' + time.toGMTString() + ';path=/'
      : GRAYSCALE_KEY + '=' + value + ';expires=' + time.toGMTString() + ';domain=' + domain + ';path=/'
  window.document.cookie = configStr
}

export function setGrayscaleMarkValue(value) {
  // 灰度标记设置值
  const domain = document.domain
  const time = new Date(new Date() * 1 + 24 * 60 * 60 * 1000)
  // Cookies.set(TokenKey, token, { expires: time, domain, path: '/' })
  // 字符串拼接cookie
  const configStr =
    process.env.NODE_ENV === 'development'
      ? GRAYSCALE_VALUE + '=' + value + ';expires=' + time.toGMTString() + ';path=/'
      : GRAYSCALE_VALUE + '=' + value + ';expires=' + time.toGMTString() + ';domain=' + domain + ';path=/'
  window.document.cookie = configStr
}

export function removeGrayscaleMark() {
  // 灰度用户标记 移除
  const domain = document.domain
  const configStr =
    process.env.NODE_ENV === 'development'
      ? GRAYSCALE_KEY + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
      : GRAYSCALE_KEY + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=' + domain
  window.document.cookie = configStr
}

export function removeGrayscaleMarkValue() {
  // 灰度用户标记 移除
  const domain = document.domain
  const configStr =
    process.env.NODE_ENV === 'development'
      ? GRAYSCALE_VALUE + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
      : GRAYSCALE_VALUE + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=' + domain
  window.document.cookie = configStr
}

export function setGrayscaleData(key, value) {
  const domain = document.domain
  const time = new Date(new Date() * 1 + 24 * 60 * 60 * 1000)
  // 字符串拼接cookie
  const configStr =
    process.env.NODE_ENV === 'development'
      ? key + '=' + value + ';expires=' + time.toGMTString() + ';path=/'
      : key + '=' + value + ';expires=' + time.toGMTString() + ';domain=' + domain + ';path=/'
  window.document.cookie = configStr
}

export function removeGrayscaleData(key) {
  const domain = document.domain
  const configStr =
    process.env.NODE_ENV === 'development'
      ? key + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
      : key + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=' + domain
  window.document.cookie = configStr
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove('CONVERAATION_TOKEN')
}
